"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useSyncExternalStore } from "react";
import { getDictationTarget, subscribeToDictationTarget } from "@/lib/dictation/target-registry";
import { useWritingTools } from "./writing-tools-context";
import { VoiceOrb } from "./voice-orb";
export function WritingToolOrb() {
  const $ = _c(10);
  const tools = useWritingTools();
  const targetId = tools?.targetId ?? null;
  let t0;
  if ($[0] !== targetId) {
    t0 = () => getDictationTarget(targetId);
    $[0] = targetId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const target = useSyncExternalStore(subscribeToDictationTarget, t0, _temp);
  let t1;
  if ($[2] !== targetId) {
    t1 = () => getDictationTarget(targetId)?.lockTarget() ?? null;
    $[2] = targetId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const lockTarget = t1;
  if (!tools?.activeTool) {
    return null;
  }
  const t2 = `${tools.activeTool}:${targetId}`;
  const t3 = tools.activeTool === "brainstorming" ? "organize" : "dictation";
  const t4 = target?.label ?? "unavailable field";
  const t5 = !target;
  let t6;
  if ($[4] !== lockTarget || $[5] !== t2 || $[6] !== t3 || $[7] !== t4 || $[8] !== t5) {
    t6 = <VoiceOrb key={t2} mode={t3} label={t4} lockTarget={lockTarget} isUnavailable={t5} />;
    $[4] = lockTarget;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}
function _temp() {
  return null;
}